const rootKey = '/accounts';

export const fetchAccounts = () => {
  return `${rootKey}/fetchAccounts`;
};

export const accounts = () => {
  return rootKey;
};

export const accountMargins = (accountId: string) => {
  return `${rootKey}/${accountId}/margins`;
};

export const accountMarginReport = () => {
  return `${rootKey}/report`;
};

export const accountsStatus = () => {
  return `${rootKey}/status`;
};

export const saveLink = () => {
  return `${rootKey}/saveLinks`;
};

export const invoices = (accountId: string) => {
  return `${rootKey}/${accountId}/invoices`;
};

export const userOnProjectStats = (accountId: string) => {
  return `${rootKey}/${accountId}/userOnProjectStats`;
};

export const fetchSowAdminAccounts = () => {
  return `${rootKey}/fetchSowAdminAccounts`;
};

export const getAccountAndProjectList = () => {
  return `${rootKey}/accounts-projects-list`;
};

export const getAccountByZohoCrmId = (zohoCrmId: string) => {
  return `${rootKey}/by-zoho-crm/${zohoCrmId}`;
};
